var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picker-container"},[_c('label',{attrs:{"for":"language-select"}}),_c('select',{ref:"languageSelect",attrs:{"id":"language-select","name":"language"}})])}
var staticRenderFns = []

export { render, staticRenderFns }